var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"249.7,388.5 97.9,483.8 141.6,309.9 4,195 182.9,182.8 249.7,16.5 316.5,182.8 495.4,195 357.8,309.9 \n\t401.6,483.8 "}));
}

StarInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 500 500","style":{"enableBackground":"new 0 0 500 500"},"xmlSpace":"preserve"};

module.exports = StarInline;

StarInline.default = StarInline;
